import React from "react";

const ModalTitle = ({ children }) => {
  return <div className="modal-title">{children}</div>;
};

export default ModalTitle;
